import { observer } from 'mobx-react';
import React from 'react';
import 'reactflow/dist/style.css';
import { Icon, INavLink, Stack, StackItem } from '@fluentui/react';
import { makeAutoObservable } from 'mobx';
import LocationContextMenuCtrl, {
	LocationContextMenuCtrlState,
} from './LocationContextMenuCtrl';
import { IContentDisplayItem } from '../state/CorporateArchiveStates/LegalEntityDocumentsState';
import LegalEntityDocument from './LegalEntityDocument';
import { IOutlookAppCommands } from '../state/CorporateArchiveStates/LegalEntityDocumentsStateOutlook';

interface ILocationLineItemCtrlProps {
	state: LocationLineItemCtrlState;
}

class LocationLineItemCtrl extends React.Component<
	ILocationLineItemCtrlProps,
	{}
> {

	render() {
		let iconName = this.props.state.isExpanded
			? 'ChevronDownMed'
			: 'ChevronRightMed';

		return (
			<div>
				<Stack>
					<StackItem>
						<Stack horizontal>
							{this.props.state.canExpand ? (
								<StackItem onClick={() => this.props.state.toggleExpanded()}>
									<Icon
										className="outlookExpandLocationChevron"
										style={{ marginRight: 5 }}
										iconName={iconName}
									/>
								</StackItem>
							) : (
								<></>
							)}

							<StackItem grow>
								<LocationContextMenuCtrl state={this.props.state.ctxMenu}>
									<Stack horizontal>

										{this.props.state.iconInfo ? (
											<StackItem>
												<div style={{ marginRight: 5 }}>
													{LegalEntityDocument.getIcon(this.props.state.iconInfo)}
												</div>
											</StackItem>
										) : (
											<></>
										)}

										<StackItem grow>{this.props.state.title}</StackItem>
									</Stack>
								</LocationContextMenuCtrl>
							</StackItem>
						</Stack>
					</StackItem>
					<StackItem>
						{this.props.state.isExpanded ? this.props.children : <></>}
					</StackItem>
				</Stack>
			</div>
		);
	}
}

export default observer(LocationLineItemCtrl);

export class LocationLineItemCtrlState {
	ctxMenu: LocationContextMenuCtrlState;

	constructor(commands: IOutlookAppCommands, navLinks: () => INavLink[], title: string) {
		this.title = title;
		this.ctxMenu = new LocationContextMenuCtrlState(navLinks);

		makeAutoObservable(this);
	}

	public iconInfo?: IContentDisplayItem;
	public setIconInfo(i: IContentDisplayItem) {
		this.iconInfo = i;
	}

	public title: string = '';
	public setTitle(title: string) {
		this.title = title;
	}

	public canExpand: boolean = true;
	public setCanExpand(v: boolean) {
		this.canExpand = v;
	}

	public isExpanded: boolean = false;
	public toggleExpanded(expanded?: boolean) {
		if (expanded === undefined) {
			this.isExpanded = !this.isExpanded;
		} else {
			this.isExpanded = expanded;
		}
	}
}